<script>
	import { fireEvent, events } from 'utilities/analyticsUtilities';
	import VisitorModal from 'components/visitor-modal.vue';
	import HeroBanner from 'components/routes/home/hero-banner.vue';
	import MessagePanel from 'components/routes/home/message-panel.vue';
	import PillarsPanel from 'components/routes/home/pillars-panel.vue';
	import NewsPanel from 'components/routes/home/news-panel.vue';
	import PartnersPanel from 'components/routes/home/partners-panel.vue';
	import FeaturedContentPanel from 'components/routes/home/featured-content-panel.vue';
	import ToolsAndFeaturesPanel from 'components/routes/home/tools-and-features-panel.vue';
	import CTAPanel from 'components/routes/home/cta-panel.vue';
	import TestimonialsPanel from 'components/routes/home/testimonials-panel.vue';
	import { homepagePanels } from 'core/metadata';

	export default {
		components: {
			'visitor-modal': VisitorModal,
			'hero-banner': HeroBanner,
			'message-panel': MessagePanel,
			'pillars-panel': PillarsPanel,
			'news-panel': NewsPanel,
			'partners-panel': PartnersPanel,
			'featured-content-panel': FeaturedContentPanel,
			'tools-and-features-panel': ToolsAndFeaturesPanel,
			'cta-panel': CTAPanel,
			'testimonials-panel': TestimonialsPanel
		},
		data() {
			return {
				panelGroups: [],
				loadedGroups: [],
				lazyObserver: undefined
			};
		},
		methods: {
			homepageClick(loc) {
				fireEvent(events.HOMEPAGE_CLICK, {
					loc
				});
			},
			getCurrentPanel(type) {
				const panelDict = {
					hero: 'hero-banner',
					desc: 'message-panel',
					pillar: 'pillars-panel',
					news: 'news-panel',
					img_list: 'partners-panel',
					features: 'featured-content-panel',
					learning_tools: 'tools-and-features-panel',
					call_to_action: 'cta-panel',
					testimonial: 'testimonials-panel'
				};

				return panelDict[type] || '';
			},
			onLazyLoaded(entries) {
				let loadedGroups = [];
				for (const entry of entries) {
					if (entry.isIntersecting) {
						loadedGroups.push(entry.target.dataset.loaderName);
					}
				}

				this.loadedGroups = loadedGroups;
			}
		},
		created() {
			this.panelGroups = homepagePanels;
			this.lazyObserver = new IntersectionObserver(this.onLazyLoaded, {
				threshold: 0.1
			});
		},
		beforeDestroy() {
			this.lazyObserver.disconnect();
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';
	@import 'mixins/media';

	.unauthenticated-homepage {
		.homepage-panel {
			&.lazy-loaded {
				.wrapper {
					opacity: 1;
				}
			}

			.wrapper {
				width: 100%;
				padding: 0 1rem;
				opacity: 0;
				transition: 0.8s opacity ease-in-out;
			}

			h2 {
				font-size: 1.875rem;
				font-weight: 500;

				@include media(med) {
					font-size: 2.25rem;
				}

				@include media(lg) {
					font-size: 2.875rem;
				}
			}

			.button {
				border-radius: 2rem;
			}
		}

		a {
			color: $c-blue-dark;

			&:hover {
				color: $c-blue-accent-1;
			}
		}

		.panel-content {
			font-family: $helvetica;
			font-size: 1.125rem;

			@include media(med) {
				font-size: 1.25rem;
			}

			@include media(lg) {
				font-size: 1.5rem;
			}
		}

		.panel-card {
			background-color: $c-white;
			box-shadow: 0 0 10px 2px rgba($c-slate, 0.15);
			border: 1px solid $c-grey;
			border-radius: 1.5rem;

			&.panel-action {
				transition:
					color 0.25s,
					border-color 0.25s,
					box-shadow 0.25s;

				&:hover {
					border-color: $c-slate-dark;
					box-shadow: 0 0 10px 2px rgba($c-slate, 0.3);
				}
			}
		}
	}
</style>
<template>
	<main class="unauthenticated-homepage font-roboto">
		<h1 class="hidden-visually">ReadWorks</h1>
		<component
			v-for="group in panelGroups"
			:key="group.name"
			class="homepage-panel"
			:is="getCurrentPanel(group.type)"
			v-lazy-loader="{
				observer: lazyObserver,
				loaded: loadedGroups.includes(group.name)
			}"
			:name="group.name"
			:data-loader-name="group.name"
			:header-text="group.header_text"
			:content-text="group.content_text"
			:panels="group.panels"></component>
		<visitor-modal></visitor-modal>
	</main>
</template>
